import reducer from "./reducer";
export { default as FunctionaryTypesSettings } from "./components/index";
export { default as functionaryTypesSettingsReducerName } from "./constants";
export default reducer;
